import React from "react"
import Layout from "../components/Layout/layout"
import AboutPage from "../components/About/aboutPage"

import Seo from "../components/About/Seo"
const About = () => {
  return (
    <Layout>
      <Seo />
      <AboutPage />
    </Layout>
  )
}

export default About
